import { useQuery } from '@apollo/client'

import { LocalCurrenciesFFQueryDocument } from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'

export const useGetLocalCurrenciesFF = ({
  brandId,
  skipWhen,
}: {
  brandId: string | undefined
  skipWhen: boolean
}) => {
  const { data, loading } = useQuery(LocalCurrenciesFFQueryDocument, {
    variables: { brandAccountId: brandId! },
    client: atlasClient,
    skip: !brandId || skipWhen,
  })
  return {
    data: !!data?.public.useJoorPayLocalPayments,
    loading,
  }
}
